const HidebuttonSvg = (props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99999 12.6667C8.63065 12.6667 9.20665 12.598 9.73199 12.4794L8.56065 11.308C8.37865 11.322 8.19399 11.3334 7.99999 11.3334C4.43265 11.3334 3.05065 8.76935 2.71599 8.00002C2.96728 7.43923 3.30668 6.92225 3.72132 6.46869L2.78932 5.53669C1.76399 6.64802 1.37532 7.76735 1.36799 7.78935C1.322 7.92626 1.322 8.07445 1.36799 8.21135C1.38199 8.25535 2.91132 12.6667 7.99999 12.6667ZM7.99999 3.33335C6.77532 3.33335 5.76932 3.59735 4.93065 3.98735L2.47132 1.52869L1.52865 2.47135L13.5287 14.4714L14.4713 13.5287L12.2587 11.316C14.0013 10.0154 14.6233 8.23935 14.6327 8.21135C14.6786 8.07445 14.6786 7.92626 14.6327 7.78935C14.618 7.74469 13.0887 3.33335 7.99999 3.33335ZM11.3147 10.372L9.79465 8.85202C9.92132 8.59202 9.99999 8.30602 9.99999 8.00002C9.99999 6.90602 9.09399 6.00002 7.99999 6.00002C7.69399 6.00002 7.40799 6.07869 7.14865 6.20602L5.94332 5.00069C6.605 4.77363 7.30046 4.66069 7.99999 4.66669C11.5673 4.66669 12.9493 7.23069 13.284 8.00002C13.0827 8.46135 12.5067 9.56135 11.3147 10.372Z"
        fill={props.fill || "#fff"}
      ></path>
    </svg>
  );
};
export default HidebuttonSvg;
